import { useState } from 'react';
import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { Dialog } from '../Dialog';
import { useAppData } from '../../state/contexts/AppDataContext';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useDisputeActions } from '../../state/actions/disputes';

// M-12: controlled fields with an inline, screen-reader-associated error
// instead of the old uncontrolled-$ reads that silently swallowed the click
// when the description was empty.
export function NewShaftDisputeModal() {
  const { cases } = useAppData();
  const { setModal } = useUIState();
  const { createShaftDisputeForCase } = useDisputeActions();
  const [caseId, setCaseId] = useState(cases[0]?.id ?? '');
  const [contentType, setContentType] = useState('Call Logo');
  const [details, setDetails] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <Dialog title="Flag SHAFT Content" onClose={() => setModal(null)}>
        <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 12 }}>S.H.A.F.T. = Sex/Adult · Hate Speech/Profanity · Alcohol · Firearms · Tobacco</div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="shaft-case" style={{ fontSize: 11, color: C.textMuted }}>Related Case</label>
          <select id="shaft-case" style={{ ...styles.select, width: '100%' }} value={caseId} onChange={e => setCaseId(e.target.value)}>
            {cases.map(c2 => <option key={c2.id} value={c2.id}>{c2.id} — {c2.registrant}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="shaft-type" style={{ fontSize: 11, color: C.textMuted }}>Content Type</label>
          <select id="shaft-type" style={{ ...styles.select, width: '100%' }} value={contentType} onChange={e => setContentType(e.target.value)}>
            <option value="Call Logo">Call Logo</option>
            <option value="Call Reason">Call Reason</option>
            <option value="Caller Display Name">Caller Display Name</option>
          </select>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="shaft-details" style={{ fontSize: 11, color: C.textMuted }}>Description of SHAFT Content *</label>
          <textarea
            id="shaft-details"
            style={{ ...styles.textarea, ...(error ? { borderColor: C.danger } : {}) }}
            placeholder="Describe the SHAFT content identified..."
            value={details}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? 'shaft-details-error' : undefined}
            onChange={e => { setDetails(e.target.value); if (error) setError(null); }}
          />
          {error && <div id="shaft-details-error" role="alert" style={{ fontSize: 11, color: C.danger, marginTop: 4 }}>{error}</div>}
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            if (!details.trim()) { setError('Description of the SHAFT content is required.'); return; }
            createShaftDisputeForCase(caseId, contentType, details);
            setModal(null);
          }}>Flag Content</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => setModal(null)}>Cancel</button>
        </div>
    </Dialog>
  );
}
